import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Loading from "../../loading";
import { styles } from "./styles";
import DialogConfirm from "../../dialog";
import Header from "../../../partials/header";
import Snackbar from "../../snackbar";
import TableFormat from "../../../partials/TableFormat";

const headCells = [
  // { key: '_id', numeric: false, disablePadding: false, label: 'No.' },
  { key: "slug", numeric: false, disablePadding: false, label: "post_slug" },
  {
    key: "featureImage",
    numeric: false,
    disablePadding: false,
    label: "post_featureImage"
  },
  { key: "title", numeric: false, disablePadding: false, label: "post_title" },
  {
    key: "description",
    numeric: false,
    disablePadding: false,
    label: "post_description"
  },
  { key: "tags", numeric: false, disablePadding: false, label: "post_tag" },
  {
    key: "categories",
    numeric: false,
    disablePadding: false,
    label: "post_category"
  },
  {
    key: "isPublish",
    numeric: false,
    disablePadding: false,
    label: "post_publish"
  },
  { key: "action", numeric: false, disablePadding: false, label: "action" }
];
class Posts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      orderBy: "createdAt",
      selected: []
    };
  }
  async componentDidMount() {
    await this.getListPost({ snackbar: this.snackbar });
  }
  delete = async (selected = []) => {
    const { t } = this.props;
    if (selected && selected.length) {
      let check = await this.props.delete({
        _id: selected,
        snackbar: this.snackbar
      });
      if (check.code === 1) {
        this.mSnackbar.handleClick(
          t("employees_listemployee_delete_successfully")
        );
        return true;
      } else {
        this.mSnackbar.handleClick(
          t("employees_listemployee_delete_successfully")
        );
        return false;
      }
    } else {
      this.mSnackbar.handleClick(t("pls_select_item"));
      return false;
    }
  };
  addNewPost = () => {
    const { history } = this.props;
    history.push("/post/create");
  };
  getListPost = async payload => {
    this.loading.startLoading();
    let check = await this.props.getList({
      ...payload
    });
    if (check && check.code === 0) {
      this.mSnackbar.handleClick(check.message);
    }
    this.loading.stopLoading();
  };
  actionColumn = (row = {}, index) => {
    const { classes, t } = this.props;
    return (
      <React.Fragment>
        <Link to={`/post/update/${row.slug}`}>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            className={classes.buttonOnRow}
          >
            {t("visitor_list_edit")}
          </Button>
        </Link>
      </React.Fragment>
    );
  };
  render() {
    const { t, list_post = [], total, count, permission = {} } = this.props;
    return (
      <div>
        <Loading onRef={id => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={snackbar => (this.mSnackbar = snackbar)}
        />
        <DialogConfirm
          onRef={dialog => (this.mDialog = dialog)}
          disagree={t("post_cancel")}
          agree={t("post_ok")}
          title={t("post_notice")}
          content={t("post_do_you_want_to_delete_this_post")}
          action={this.delete}
        />
        {permission.module &&
        permission.module.post &&
        permission.module.post.insert ? (
          <Header
            session={t("sidebar_cms")}
            title={t("post_list_posts")}
            button={t("post_create_posts")}
            actionButton={this.addNewPost}
          />
        ) : (
          <Header session={t("sidebar_cms")} title={t("post_list_posts")} />
        )}
        <TableFormat
          onRef={ref => (this.mTable = ref)}
          orderBy=""
          contentDialog={t("post_do_you_want_to_delete_this_post")}
          onDelete={this.delete}
          title={t("post_list_posts")}
          showFilter={false}
          showActionToolbar={false}
          placeholder={t("post_search_by_title_description_slug")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={false}
          actionColumn={this.actionColumn}
          getList={this.getListPost}
          rows={list_post.map((row, index) => {
            let { title, description, featureImage } =
              row.langContent && row.langContent.length
                ? row.langContent[0]
                : row;
            let categories = row.categories
              ? row.categories
                  .filter(e => e.name)
                  .map(e => e.name)
                  .join(", ")
              : "";
            return {
              id: row._id,
              slug: row.slug,
              featureImage: (
                <div style={{ maxWidth: "100px" }}>
                  <img style={{ maxWidth: "100%" }} src={featureImage} />
                </div>
              ),
              title: title,
              description: description,
              tags: row.tags,
              categories: categories,
              isPublish: row.isPublish
                ? t("post_publish_true")
                : t("post_publish_false"),
              slug: row.slug
            };
          })}
        />
      </div>
    );
  }
}

Posts.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};
const mapState = state => ({
  list_post: state.posts.list_post,
  total: state.posts.total,
  count: state.posts.count,
  permission: state.user.user.roleId
});

const mapDispatch = dispatch => ({
  getList: dispatch.posts.getList,
  delete: dispatch.posts.delete
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Posts)));
